<template>
  <h2 class="basetitle">{{ titleText }}</h2>
</template>

<script>
export default {
  name: 'BaseTitle',
  props: {
    titleText: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.basetitle {
  text-align: center;
}
</style>
